// Imports
var ___CSS_LOADER_API_IMPORT___ = require("C:\\Users\\vinod\\AppData\\Local\\Yarn\\Data\\global\\node_modules\\css-loader\\dist\\runtime\\api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Nunito:200,200i,300,300i,400,400i,600,600i,700,700i,800,800i,900,900i);"]);
// Module
exports.push([module.id, "", ""]);
// Exports
module.exports = exports;
